import socketIOClient from "socket.io-client";
import PatientsCallApi from "./PatientsCallApi";

const ENDPOINT = process.env.REACT_APP_PUBLIC_URL.toString().substring(0, process.env.REACT_APP_PUBLIC_URL.toString().length - 1);
const socket = socketIOClient(ENDPOINT, {
    autoConnect: false
});

class PatientsCallSocket {

    //Envia los Datos del paciente y el Consultorio
    async callPacient(admision) {
        return new Promise(function (resolve, reject) {
            socket.open();
            socket.emit('comprobateAdmision', admision.id_admision);
            socket.on('comprobateAdmisionResponse', function (called) {
                socket.disconnect();
                resolve(called);
            });
        });
    }

    async joinPatient(admision) {
        await PatientsCallApi.getSpaceAdmision(admision).then((res) => {
            return new Promise(function (resolve, reject) {
                socket.open();
                socket.emit('joinPatient', res, function () {
                    console.log(admision);
                    socket.disconnect();
                    resolve();
                });
            });
        }).catch((err) => {
            console.log(err);
            return null;
        });
    }


    //Pide al Servidor que le traiga la lista de Pacientes en Sala de Espera
    async emmitPatientsList(paciente) {
        return new Promise(function (resolve, reject) {
            socket.open();
            socket.emit('patientsList');
            resolve();
        });
    }

    //Muestra los Pacientes que estan en Sala de Espera
    async getPatientAndSpace() {
        return new Promise(function (resolve, reject) {
            socket.open();
            socket.on("patientsList", function (data) {
                socket.disconnect();
                this.patients = data;
                resolve(this.patients);
            });
        });
    }

    //Limpia la Memoria Temporal de Pacientes en el Servidor
    async clearPatients(paciente) {
        return new Promise(function (resolve, reject) {
            socket.open();
            socket.emit('clearPatients');
            socket.disconnect();
            resolve();
        });
    }
}

export default new PatientsCallSocket();
